const Pincode = {

    // FIELDS
    "city": "City",
    "pincode": "Pincode",
    "delivery_available": "Delivery Available",
    "cod_available": "COD Available",
    "estimated_days": "Estimated Days",
    "min_order_value": "Min. Order Value",
    "delivery_fee": "Delivery Fee",
    "search": "Search",
    "yes": "Yes",
    "no": "No",

    // PAGE HEADER
    "pincode_title": "Pincode",

    // ERROR
    "error_city": "Select City",
    "error_pincode": "Enter Pincode",
    "error_pincode_invalid": "Pincode must be 6 digits",
    "error_estimated_days": "Enter Estimated Days",
    "error_min_order_value": "Enter Min. Order Value",
    "error_delivery_fee": "Enter Delivery Fee",

    // TABLE HEADER
    "table_city": "CITY",
    "table_pincode": "PINCODE",
    "table_delivery_available": "DELIVERY",
    "table_cod_available": "COD",
    "table_estimated_days": "EST. DAYS",
    "table_min_order_value": "MIN. ORDER",
    "table_delivery_fee": "DELIVERY FEE",

}

export default Pincode;